import React, { useTranslation } from "react-i18next";
import { Flex, Stack, Grid, Title } from "@mantine/core";
import { CardStatusCompare } from "../../components/Card/CardStatusCompare";
import colorsCustom from "../../designTokens/colorsCustom";
import styled from "styled-components";
import { CardContainerRetro } from "../../components/Container/CardContainerRetro";

const Col = styled(Grid.Col)`
  /* padding: 0 16px; */
`;
const Block = styled(Flex)`
  border-right: ${(props) =>
    `solid ${props.$isEnd ? "0" : "0.5px"} ${colorsCustom.ui.dark.subtle}`};
  margin-bottom: ${(props) => (props.$isMobile ? "16px" : "0px")};
`;

export const CollectionKeyMetricSummarySection = ({
  views,
  likes,
  replies,
  reposts,
  isXL,
  isSM,
  numOfThreads,
}) => {
  const { t } = useTranslation();

  return (
    <Stack gap={isXL ? 8 : 16} w={"100%"}>
      <Title order={isXL ? 5 : 3} fw={700} mt={8}>
        {t("collectionPage.summaryTitle", { numOfThreads })}
      </Title>
      <CardContainerRetro
        bg={colorsCustom.paper}
        w={"100%"}
        weight="bold"
        rd={16}
      >
        <Flex
          w={"100%"}
          p={isXL ? "16px" : "24px"}
          gap={24}
          direction={"column"}
        >
          <Grid
            direction={"row"}
            w={"100%"}
            // h={isSM ? '' : 109}
            gutter={isSM ? 16 : 24}
            p={"0px"}
            style={{
              display: "flex",
              alignItems: "stretch",
            }}
          >
            <Col span={isSM ? 6 : 3}>
              <Block>
                <CardStatusCompare
                  type={"view"}
                  value1={views}
                  value2={views / numOfThreads}
                  postLoading={false}
                  isMobile={isSM}
                />
              </Block>
            </Col>
            <Col span={isSM ? 6 : 3}>
              <Block $isEnd={isSM}>
                <CardStatusCompare
                  type={"like"}
                  value1={likes}
                  value2={likes / numOfThreads}
                  postLoading={false}
                  isMobile={isSM}
                />
              </Block>
            </Col>
            <Col span={isSM ? 6 : 3}>
              <Block>
                <CardStatusCompare
                  type={"reply"}
                  value1={replies}
                  value2={replies / numOfThreads}
                  postLoading={false}
                  isMobile={isSM}
                />
              </Block>
            </Col>
            <Col span={isSM ? 6 : 3}>
              <Block $isEnd={true}>
                <CardStatusCompare
                  type={"repost"}
                  value1={reposts}
                  value2={reposts / numOfThreads}
                  postLoading={false}
                  isMobile={isSM}
                />
              </Block>
            </Col>
          </Grid>
        </Flex>
      </CardContainerRetro>
    </Stack>
  );
};
